// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("./imgs/check-large.svg", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Checkbox-module__root--WbTnL {
  --checkbox-indicator-width: 22px;
  --checkbox-indicator-height: 22px;
  --checkbox-unchecked-size: 14px;
  --checkbox-checked-size: 12px;
  --checkbox-radius: 2px;
  --checkbox-check-width: 6px;
  --checkbox-check-height: 3px;
  --checkbox-check-border-width: 1px;
  --checkbox-check-image: none;
  --checkbox-check-transform: translateY(-1px) rotate(-45deg);

  display: inline-flex;
  align-items: center;
  gap: 8px;
  color: var(--chaek-color-text-primary);
  cursor: pointer;
}

.Checkbox-module__size-large--3gf3s {
  --checkbox-unchecked-size: 22px;
  --checkbox-checked-size: 22px;
  --checkbox-radius: 4px;
  --checkbox-check-width: 14px;
  --checkbox-check-height: 14px;
  --checkbox-check-border-width: 0;
  --checkbox-check-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
  --checkbox-check-transform: none;
}

.Checkbox-module__is-boxed--JQAH7 {
  --checkbox-indicator-width: 24px;
  --checkbox-indicator-height: 30px;

  box-sizing: border-box;
  height: 50px;
  align-items: flex-start;
  gap: 12px;
  padding: 12px 16px;
  border-radius: 15px;
  background-color: var(--chaek-color-surface-subtle);
  font-family: var(--chaek-font-family-gowun-dodum);
  font-size: 14px;
  line-height: 21px;
  letter-spacing: -0.150390625px;
}

.Checkbox-module__is-boxed--JQAH7 + .Checkbox-module__is-boxed--JQAH7 {
  margin-top: 16px;
}

.Checkbox-module__is-block--jCwyT {
  display: flex;
}

.Checkbox-module__input--Xo_C8 {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  border: 0;
  margin: -1px;
  clip: rect(0, 0, 0, 0);
  clip-path: inset(50%);
  overflow: hidden;
  white-space: nowrap;
}

.Checkbox-module__indicator--n2onw {
  position: relative;
  box-sizing: border-box;
  display: inline-flex;
  width: var(--checkbox-indicator-width);
  height: var(--checkbox-indicator-height);
  flex: 0 0 var(--checkbox-indicator-width);
  align-items: center;
  justify-content: center;
}

.Checkbox-module__input--Xo_C8:not(:checked) + .Checkbox-module__indicator--n2onw::before {
  box-sizing: border-box;
  width: var(--checkbox-unchecked-size);
  height: var(--checkbox-unchecked-size);
  border: 1px solid var(--chaek-color-text-secondary);
  border-radius: var(--checkbox-radius);
  content: '';
}

.Checkbox-module__input--Xo_C8:checked + .Checkbox-module__indicator--n2onw::before {
  width: var(--checkbox-checked-size);
  height: var(--checkbox-checked-size);
  border-radius: var(--checkbox-radius);
  background-color: var(--chaek-color-text-accent);
  content: '';
}

.Checkbox-module__input--Xo_C8:checked + .Checkbox-module__indicator--n2onw::after {
  position: absolute;
  width: var(--checkbox-check-width);
  height: var(--checkbox-check-height);
  border-bottom: var(--checkbox-check-border-width) solid var(--chaek-color-text-inverse);
  border-left: var(--checkbox-check-border-width) solid var(--chaek-color-text-inverse);
  background-image: var(--checkbox-check-image);
  background-repeat: no-repeat;
  background-size: contain;
  content: '';
  transform: var(--checkbox-check-transform);
}

.Checkbox-module__input--Xo_C8:focus-visible + .Checkbox-module__indicator--n2onw {
  outline: 2px solid var(--chaek-color-border-strong);
  outline-offset: 2px;
}

.Checkbox-module__root--WbTnL:has(.Checkbox-module__input--Xo_C8:disabled) {
  cursor: not-allowed;
  opacity: 0.45;
}

.Checkbox-module__label--aWHgk {
  min-width: 0;
  flex: 1 1 auto;
  font: inherit;
}
`, "",{"version":3,"sources":["webpack://./../../packages/design-system/src/components/Checkbox/Checkbox.module.css"],"names":[],"mappings":"AAAA;EACE,gCAAgC;EAChC,iCAAiC;EACjC,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,2BAA2B;EAC3B,4BAA4B;EAC5B,kCAAkC;EAClC,4BAA4B;EAC5B,2DAA2D;;EAE3D,oBAAoB;EACpB,mBAAmB;EACnB,QAAQ;EACR,sCAAsC;EACtC,eAAe;AACjB;;AAEA;EACE,+BAA+B;EAC/B,6BAA6B;EAC7B,sBAAsB;EACtB,4BAA4B;EAC5B,6BAA6B;EAC7B,gCAAgC;EAChC,+DAAqD;EACrD,gCAAgC;AAClC;;AAEA;EACE,gCAAgC;EAChC,iCAAiC;;EAEjC,sBAAsB;EACtB,YAAY;EACZ,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,mBAAmB;EACnB,mDAAmD;EACnD,iDAAiD;EACjD,eAAe;EACf,iBAAiB;EACjB,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,WAAW;EACX,UAAU;EACV,SAAS;EACT,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,oBAAoB;EACpB,sCAAsC;EACtC,wCAAwC;EACxC,yCAAyC;EACzC,mBAAmB;EACnB,uBAAuB;AACzB;;AAEA;EACE,sBAAsB;EACtB,qCAAqC;EACrC,sCAAsC;EACtC,mDAAmD;EACnD,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,mCAAmC;EACnC,oCAAoC;EACpC,qCAAqC;EACrC,gDAAgD;EAChD,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,kCAAkC;EAClC,oCAAoC;EACpC,uFAAuF;EACvF,qFAAqF;EACrF,6CAA6C;EAC7C,4BAA4B;EAC5B,wBAAwB;EACxB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mDAAmD;EACnD,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,cAAc;EACd,aAAa;AACf","sourcesContent":[".root {\n  --checkbox-indicator-width: 22px;\n  --checkbox-indicator-height: 22px;\n  --checkbox-unchecked-size: 14px;\n  --checkbox-checked-size: 12px;\n  --checkbox-radius: 2px;\n  --checkbox-check-width: 6px;\n  --checkbox-check-height: 3px;\n  --checkbox-check-border-width: 1px;\n  --checkbox-check-image: none;\n  --checkbox-check-transform: translateY(-1px) rotate(-45deg);\n\n  display: inline-flex;\n  align-items: center;\n  gap: 8px;\n  color: var(--chaek-color-text-primary);\n  cursor: pointer;\n}\n\n.size-large {\n  --checkbox-unchecked-size: 22px;\n  --checkbox-checked-size: 22px;\n  --checkbox-radius: 4px;\n  --checkbox-check-width: 14px;\n  --checkbox-check-height: 14px;\n  --checkbox-check-border-width: 0;\n  --checkbox-check-image: url('./imgs/check-large.svg');\n  --checkbox-check-transform: none;\n}\n\n.is-boxed {\n  --checkbox-indicator-width: 24px;\n  --checkbox-indicator-height: 30px;\n\n  box-sizing: border-box;\n  height: 50px;\n  align-items: flex-start;\n  gap: 12px;\n  padding: 12px 16px;\n  border-radius: 15px;\n  background-color: var(--chaek-color-surface-subtle);\n  font-family: var(--chaek-font-family-gowun-dodum);\n  font-size: 14px;\n  line-height: 21px;\n  letter-spacing: -0.150390625px;\n}\n\n.is-boxed + .is-boxed {\n  margin-top: 16px;\n}\n\n.is-block {\n  display: flex;\n}\n\n.input {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  border: 0;\n  margin: -1px;\n  clip: rect(0, 0, 0, 0);\n  clip-path: inset(50%);\n  overflow: hidden;\n  white-space: nowrap;\n}\n\n.indicator {\n  position: relative;\n  box-sizing: border-box;\n  display: inline-flex;\n  width: var(--checkbox-indicator-width);\n  height: var(--checkbox-indicator-height);\n  flex: 0 0 var(--checkbox-indicator-width);\n  align-items: center;\n  justify-content: center;\n}\n\n.input:not(:checked) + .indicator::before {\n  box-sizing: border-box;\n  width: var(--checkbox-unchecked-size);\n  height: var(--checkbox-unchecked-size);\n  border: 1px solid var(--chaek-color-text-secondary);\n  border-radius: var(--checkbox-radius);\n  content: '';\n}\n\n.input:checked + .indicator::before {\n  width: var(--checkbox-checked-size);\n  height: var(--checkbox-checked-size);\n  border-radius: var(--checkbox-radius);\n  background-color: var(--chaek-color-text-accent);\n  content: '';\n}\n\n.input:checked + .indicator::after {\n  position: absolute;\n  width: var(--checkbox-check-width);\n  height: var(--checkbox-check-height);\n  border-bottom: var(--checkbox-check-border-width) solid var(--chaek-color-text-inverse);\n  border-left: var(--checkbox-check-border-width) solid var(--chaek-color-text-inverse);\n  background-image: var(--checkbox-check-image);\n  background-repeat: no-repeat;\n  background-size: contain;\n  content: '';\n  transform: var(--checkbox-check-transform);\n}\n\n.input:focus-visible + .indicator {\n  outline: 2px solid var(--chaek-color-border-strong);\n  outline-offset: 2px;\n}\n\n.root:has(.input:disabled) {\n  cursor: not-allowed;\n  opacity: 0.45;\n}\n\n.label {\n  min-width: 0;\n  flex: 1 1 auto;\n  font: inherit;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"root": `Checkbox-module__root--WbTnL`,
	"size-large": `Checkbox-module__size-large--3gf3s`,
	"is-boxed": `Checkbox-module__is-boxed--JQAH7`,
	"is-block": `Checkbox-module__is-block--jCwyT`,
	"input": `Checkbox-module__input--Xo_C8`,
	"indicator": `Checkbox-module__indicator--n2onw`,
	"label": `Checkbox-module__label--aWHgk`
};
export default ___CSS_LOADER_EXPORT___;
